<template>
  <v-row
    justify="space-between"
    no-gutters
  >
    <div class="header-right" style="display: inline-flex;">
      <h2>{{$tc('transport_request.transport_request', 2)}}</h2>
      <!-- <ais-instant-search
        :search-client="search.searchClient"
        index-name="prod_orders"
      > -->
        <!-- <ais-search-box>
          <v-text-field
            prepend-inner-icon="search"
            :label="$t('search')"
            class="box-search-box"
            solo
            v-model="search.query"
          />
        </ais-search-box> -->
      <!-- </ais-instant-search> -->
    </div>
    <div>
      <v-row no-gutters class="pb-3">
        <!-- <v-flex>
          <ExportOrders />
        </v-flex> -->
        <v-col>
          <AlgoliaRefresh />
        </v-col>
        <v-col>
          <v-dialog v-model="dialog" class="text-center">
            <template v-slot:activator="{ on }">
              <v-btn
                class="mr-4"
                color="accent"
                v-on="on"
              >{{$t('transport_request.import')}}</v-btn>
            </template>
            <v-card>
              <v-card-title class="title justify-center">
                {{$t('transport_request.import_request')}}
              </v-card-title>
              <v-spacer></v-spacer>
              <v-card-actions class="justify-center">
                <v-btn @click="dialog = false" color="accent" class="white--text">{{$t('transport_request.close')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
        <v-col>
          <v-btn
            class="mr-4"
            color=accent
            @click="gotoTransportRequest()"
          >{{$t('buttons.create')}}</v-btn>
        </v-col>
      </v-row>
    </div>
  </v-row>
</template>

<script>
import router from '@/router'
import { createWidgetMixin } from 'vue-instantsearch'
import AlgoliaRefresh from '@/components/general/AlgoliaRefresh'
import ExportOrders from '@/components/general/ExportOrders'

export default {
  name: 'TransportRequestListHeader',
  components: {
    AlgoliaRefresh,
    ExportOrders
  },
  props: {
    search: {
      type: Object
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  computed: {},
  mixins: [createWidgetMixin({ connector: true })],
  methods: {
    gotoTransportRequest () {
      router.push({ name: 'TransportRequestCreate' })
    },
    refreshAlgolia () {
      let tmpQuery = this.search.query
      this.search.query = 'a'
      this.search.query = tmpQuery
    }
  }
}
</script>

<style lang="scss" scoped>
  h2 {
    padding-left: 25px;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.02em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .header-right {
    display: inline-flex;
    margin-top: 6px;
  }
</style>
